/**
 * Field readers for RunViews rows (OEPDataService.Batch returns field bags: each query picks its own
 * Fields, so callers narrow per field). Shared by every OEP view and the context service.
 */
export type OEPRow = Record<string, unknown>; // unknown: a RunViews field bag, narrowed per field by the readers below

export const Str = (r: OEPRow, f: string): string => String(r[f] ?? '');
export const StrOrNull = (r: OEPRow, f: string): string | null => (r[f] === null || r[f] === undefined ? null : String(r[f]));
export const NumOrNull = (r: OEPRow, f: string): number | null => (r[f] === null || r[f] === undefined ? null : Number(r[f]));
export const DateOrNull = (r: OEPRow, f: string): Date | null => (r[f] === null || r[f] === undefined ? null : new Date(String(r[f])));
/** SQL Server returns GUIDs upper-case; the client may hold lower-case. Compare through this. */
export const Up = (s: string): string => s.toUpperCase();
